import DocumentEditPage, { DocumentEditConfig } from 'src/document-editor/edit/DocumentEditPage';

const config: DocumentEditConfig = {
  pageType: 'suitability-report-edit',
  title: 'Suitability Report',
  documentTypePath: 'suitability-reports',
  documentLabel: 'suitability report',
};

export default function SuitabilityReportEditPage() {
  return <DocumentEditPage config={config} />;
}
